import moment from 'moment'
import {CSRGroupBy} from '../core/_models'

export const formatPeriod = (period?: string, groupBy?: CSRGroupBy, locales?: string, timeZone?: string) => {
  if (!period) return '—'
  const tz = timeZone || moment.tz.guess()
  const [rawStart, rawEnd] = period.split(',')
  const startUtc = moment.utc(rawStart)
  if (!startUtc.isValid()) return '—'
  const start = startUtc.clone().tz(tz)
  let end: moment.Moment

  if (rawEnd) {
    const endUtc = moment.utc(rawEnd)
    end = endUtc.clone().tz(tz)
  } else {
    if (groupBy === 'day') {
      const day = new Intl.DateTimeFormat(locales, {
        day: 'numeric',
        month: 'long',
      }).format(new Date(period))
      const labelDay = new Intl.DateTimeFormat(locales, {weekday: 'short'}).format(new Date(period))
      return `${day}, ${labelDay}`
    } else if (groupBy === 'week') {
      end = start.clone().endOf('week')
    } else if (groupBy === 'month') {
      end = start.clone().endOf('month')
    } else {
      end = start.clone()
    }
  }

  const fmt = new Intl.DateTimeFormat(locales, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })

  if (groupBy === 'month') {
    return new Intl.DateTimeFormat(locales, {
      month: 'short',
      year: 'numeric',
    }).format(start.toDate())
  }

  return `${fmt.format(start.toDate())} - ${fmt.format(end.toDate())}`
}
